var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._b({attrs:{"outlined":"","dense":"","single-line":""},on:{"change":function($event){return _vm.$emit('update', _vm.text)}},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}},'v-textarea',{
    rows: 6,
    ..._vm.$attrs,
  },false))
}
var staticRenderFns = []

export { render, staticRenderFns }